import { render, staticRenderFns } from "./showAppls.vue?vue&type=template&id=c36745d8&"
import script from "./showAppls.vue?vue&type=script&lang=js&"
export * from "./showAppls.vue?vue&type=script&lang=js&"
import style0 from "./showAppls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports